import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getRecap } from '../../utils/helpers/recapBudget'

class DevisRecap extends Component {
  static propTypes = {
    allDevisBeneficiaires: PropTypes.array.isRequired,
  }

  render() {
    const { allDevisBeneficiaires } = this.props
    let recap = getRecap(allDevisBeneficiaires)
    return(
      <table className="uk-table uk-table-divider">
        <tbody>
          <tr>
            <td className="aps-dashboard-table-recap-w aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
              Budget brut santé
            </td>
            <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
              {recap.bgb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA
            </td>
          </tr>
          <tr>
            <td className="aps-dashboard-table-recap-w aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
              Réduction famille
            </td>
            <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
              - {recap.familyDiscount} %
            </td>
          </tr>
          <tr>
            <td className="aps-dashboard-table-recap-w aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
              Budget option Prévoyance Familiales
            </td>
            <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
              {recap.boia.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA
            </td>
          </tr>

          <tr>
            <td className="aps-dashboard-table-recap-w aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
              Accessoires (droit d’adhésion annuel à l’APS : 5 000 F CFA par
              individu ou 10 000 F CFA par famille + coût de police : 5 000 F CFA)
            </td>
            <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
              {recap.droitsAdhesion.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA
            </td>
          </tr>
          <tr className="aps-dashboard-devis-border-mobile-background">
            <td className="aps-dashboard-table-recap-w aps-dashboard-devis-border-all uk-text-bold aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile aps-dashboard-devis-budget-mobile">
              Budget global par an
            </td>
            <td className="aps-dashboard-devis-border-all uk-text-right uk-text-bold aps-dashboard-devis-border-all-padding-right aps-dashboard-devis-budget-mobile">
              {recap.bga.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA
            </td>
          </tr>
          <tr>
            <td className="aps-dashboard-table-recap-w aps-dashboard-devis-border-all aps-dashboard-devis-border-all-padding-left aps-dashboard-devis-border-mobile">
              Budget global par mois
            </td>
            <td className="aps-dashboard-devis-border-all uk-text-right aps-dashboard-devis-border-all-padding-right">
              {Math.round(recap.bgm).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} F CFA
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}



export default DevisRecap



// WEBPACK FOOTER //
// ./src/components/DevisRecap/index.js